import CrudeSummaryBrief from './crudeSummaryBrief';

export default CrudeSummaryBrief;